export default {
  companyInfo: "company",
  companies: "company/companies",
};
